/**
 * The create screen's prompt box: a framed input with the Attach / Adapt / Align row on the
 * left and actions on the right. Shared with the Courses chat input so both look the same.
 *
 * @param {Object} props
 * @param {React.ReactNode} [props.top] - attachment chips (and hidden file inputs) above the input
 * @param {React.ReactNode} props.children - the input itself (see PROMPT_TEXTAREA_CLASSES)
 * @param {React.ReactNode} props.menus - left side of the bottom row
 * @param {React.ReactNode} props.actions - right side of the bottom row
 */
export const PromptBox = ({ top, children, menus, actions }) => (
  <div className='flex flex-col bg-white rounded-3xl border border-gray-200 shadow-[0_4px_10px_-1px_rgba(0,0,0,0.05),0_2px_6px_-2px_rgba(0,0,0,0.03)] focus-within:border-gray-300'>
    {top}
    {children}
    <div className='flex items-end justify-between pb-2'>
      <div className='flex items-center mb-1 min-w-0 gap-0.5 md:gap-2'>{menus}</div>
      <div className='flex items-center gap-1 mr-1'>{actions}</div>
    </div>
  </div>
);

export const PROMPT_TEXTAREA_CLASSES =
  'w-full pt-6 pb-4 px-6 text-lg text-gray-900 bg-transparent border-none focus:ring-0 focus:outline-none disabled:opacity-50 resize-none overflow-hidden caret-emerald-600';

export const PROMPT_SEND_BUTTON_CLASSES =
  'p-2.5 my-1 mx-2 bg-emerald-600 text-white rounded-xl hover:bg-emerald-700 transition-colors cursor-pointer';

/** The chip an attached file shows above the input. */
export const PROMPT_CHIP_CLASSES =
  'inline-flex items-center gap-2 pl-3 pr-1.5 py-1.5 bg-gray-50 border border-gray-200 rounded-lg max-w-full';
